module.exports = __webpack_public_path__ + "static/media/pull-up-chevron.f23f3f3a.svg";